<template>
	<div class="container">
		<div class="content">
			<!-- 查询卡片 -->
			<div class="search-card">
				<div class="search-header">
					<div class="search-icon">
						<i class="el-icon-s-order"></i>
					</div>
					<div>
						<div class="search-title">保单查询</div>
						<div class="search-subtitle">通过以下条件查询您的保单信息</div>
					</div>
				</div>

				<form class="search-form" @submit.prevent="handleSearch">
					<div class="form-group">
						<label class="form-label">保单号</label>
						<input v-model="form.policy_no" type="text" class="form-input" placeholder="请输入保单号码">
					</div>
					<div class="form-group">
						<label class="form-label">投保人信息</label>
						<input v-model="form.applicant_info" type="text" class="form-input" placeholder="证件号码、联系电话">
					</div>
					<div class="search-actions">
						<button type="submit" class="btn btn-primary" :disabled="loading">
							<i class="el-icon-search"></i>
							{{ loading ? '查询中...' : '查询保单' }}
						</button>
						<button @click="reset" type="button" class="btn btn-secondary" :disabled="loading">
							<i class="el-icon-refresh-right"></i>
							重置条件
						</button>
					</div>
				</form>
			</div>

			<!-- 查询结果 -->
			<div class="results-card" v-if="isSearch">
				<div class="results-header">
					<div class="results-title">
						<i class="el-icon-s-order"></i>
						查询结果
					</div>
					<div class="results-count" v-if="!loading">共找到 {{ total }} 份保单</div>
				</div>

				<!-- 加载状态 -->
				<div v-if="loading" class="loading-state">
					<i class="el-icon-loading"></i>
					<span>正在查询中...</span>
				</div>

				<!-- 空状态 -->
				<div v-else-if="list.length === 0" class="empty-state">
					<div class="empty-icon">
						<i class="el-icon-document"></i>
					</div>
					<div class="empty-text">暂无保单数据</div>
					<div class="empty-desc">请尝试调整查询条件或联系客服</div>
				</div>

				<!-- 数据表格 -->
				<table v-else class="results-table">
					<thead>
						<tr>
							<th width="20%">保单信息</th>
							<th width="25%">保险期间</th>
							<th width="15%">保费金额</th>
							<th width="15%">保单状态</th>
							<th width="25%">操作</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in list" :key="index">
							<td>
								<div class="policy-info">
									<div class="policy-name">{{ item.goods_name || '未知产品' }}</div>
									<div class="policy-number">保单号: {{ item.policy_no || '暂未生成' }}</div>
									<div class="policy-time" v-if="item.create_time">投保时间: {{ formatTime(item.create_time) }}</div>
								</div>
							</td>
							<td>
								<div class="policy-period">
									<div>{{ item.pln_start_date || '-' }}</div>
									<div>至</div>
									<div>{{ item.pln_end_date || '-' }}</div>
								</div>
							</td>
							<td class="policy-amount">¥{{ formatAmount(item.amount) }}</td>
							<td>
								<span :class="'policy-status status-' + (item.status || 0)">{{ item.statusText }}</span>
							</td>
							<td>
								<div class="policy-actions">
									<button @click="$navto('/my/insureDetail?id=' + item.id)" class="action-btn">
										<i class="el-icon-view"></i>
										查看详情
									</button>
									<button v-if="item.status === 2" @click="downloadPolicy(item)" class="action-btn primary">
										<i class="el-icon-download"></i>
										下载保单
									</button>
									<button v-else class="action-btn" disabled>
										<i class="el-icon-download"></i>
										暂不可下载
									</button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				
				<!-- 分页 -->
				<div class="pagination" v-if="list.length > 0 && total > form._size">
					<el-pagination 
						background 
						layout="prev, pager, next, total" 
						:total="total" 
						:page-size="form._size"
						:current-page="form._page"
						@current-change="currentChange"
					/>
				</div>
			</div>
		</div>

		<mainFooter />
	</div>
</template>

<script>
	import mainFooter from '../../../../src/basic/components/layout/mainFooter.vue';
	export default {
		components: {
			mainFooter,
		},
		data() {
			return {
				form: {
					_page: 1,
					_size: 10,
					_order: 'id',
					_isreverse: 1,
					applicant_info: '',
					policy_no: '',
				},
				list: [],
				total: 0,
				loading: false,
				isSearch: 0,
			}
		},
		mounted() {
			
		},
		methods: {
			// 格式化金额
			formatAmount(amount) {
				return parseFloat(amount || 0).toFixed(2);
			},
			
			// 格式化时间
			formatTime(time) {
				if (!time) return '-';
				return time.split(' ')[0]; // 只显示日期部分
			},
			
			// 处理搜索
			handleSearch() {
				this.form._page = 1;
				if( !this.form.applicant_info && !this.form.policy_no ){
					return this.$warning('请输入查询条件');
				}
				this.ActionList();
			},
			
			// 重置表单
			reset(){
				this.form._page = 1;
				this.form.applicant_info = '';
				this.form.policy_no = '';
			},
			
			// 分页切换
			currentChange(e){
				this.form._page = e;
				this.ActionList();
			},
			
			// 下载保单
			downloadPolicy(item) {
				this.$warning('暂无保单');
			},
			
			// 获取列表数据
			ActionList(){
				this.loading = true;
				this.$load();
				this.$get('app-order', this.form, true).then(res => {
					this.list = res.data || [];
					if (res.extra && res.extra.pageInfo) {
						this.total = res.extra.pageInfo.count || 0;
					} else {
						this.total = this.list.length;
					}
					this.loading = false;
					this.isSearch = true;
				}).catch(err => {
					this.$warning(err);
					this.list = [];
					this.total = 0;
					this.loading = false;
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		background-color: #F7F7F7;

		.content {
			min-height: calc(100vh - 300px);
			margin: 20px auto 40px;
			width: 68%;
			gap: 24px;
			display: grid;
			grid-template-columns: 1fr;
			
			// 笔记本适配
			@media (max-width: 1440px) {
				width: 80%;
			}
			
			@media (max-width: 1280px) {
				width: 90%;
				margin: 15px auto 30px;
				gap: 20px;
			}
			
			@media (max-width: 1024px) {
				width: 95%;
				margin: 10px auto 20px;
				gap: 16px;
			}
		}

		/* 查询卡片 */
		.search-card {
			background: white;
			border-radius: 12px;
			padding: 30px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
			height: 320px;
			
			// 笔记本适配
			@media (max-width: 1280px) {
				padding: 24px;
				height: auto;
				min-height: 280px;
			}
			
			@media (max-width: 1024px) {
				padding: 20px;
				border-radius: 8px;
			}
			
			@media (max-width: 768px) {
				padding: 16px;
			}
		}

		.search-header {
			display: flex;
			align-items: center;
			gap: 12px;
			margin-bottom: 24px;
			padding-bottom: 16px;
			border-bottom: 1px solid #f0f0f0;
			
			// 笔记本适配
			@media (max-width: 1280px) {
				margin-bottom: 20px;
				padding-bottom: 12px;
			}
		}

		.search-icon {
			width: 48px;
			height: 48px;
			background: rgba(34, 128, 253, 0.1);
			color: #2280FD;
			border-radius: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 20px;
			
			// 笔记本适配
			@media (max-width: 1280px) {
				width: 40px;
				height: 40px;
				font-size: 18px;
				border-radius: 8px;
			}
		}

		.search-title {
			font-size: 20px;
			font-weight: 600;
			color: #333;
			
			// 笔记本适配
			@media (max-width: 1280px) {
				font-size: 18px;
			}
			
			@media (max-width: 768px) {
				font-size: 16px;
			}
		}

		.search-subtitle {
			font-size: 14px;
			color: #666;
			margin-top: 4px;
			
			// 笔记本适配
			@media (max-width: 768px) {
				font-size: 13px;
			}
		}

		.search-form {
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			gap: 20px;
			
			// 笔记本适配
			@media (max-width: 1024px) {
				grid-template-columns: repeat(2, 1fr);
				gap: 16px;
			}
			
			@media (max-width: 768px) {
				grid-template-columns: 1fr;
				gap: 12px;
			}
		}

		.form-group {
			display: flex;
			flex-direction: column;
			gap: 8px;
		}

		.form-label {
			font-size: 14px;
			color: #666;
			font-weight: 500;
			
			// 笔记本适配
			@media (max-width: 768px) {
				font-size: 13px;
			}
		}

		.form-input,
		.form-select {
			padding: 12px 16px;
			border: 1px solid #e0e0e0;
			border-radius: 8px;
			font-size: 14px;
			color: #333;
			transition: all 0.3s ease;
			background: white;
			
			// 笔记本适配
			@media (max-width: 1280px) {
				padding: 10px 14px;
				font-size: 13px;
			}
		}

		.form-input:focus,
		.form-select:focus {
			outline: none;
			border-color: #2280FD;
			box-shadow: 0 0 0 3px rgba(34, 128, 253, 0.1);
		}

		.form-input:disabled,
		.form-select:disabled {
			background: #f5f5f5;
			color: #999;
			cursor: not-allowed;
		}

		.search-actions {
			grid-column: 1 / -1;
			display: flex;
			gap: 12px;
			margin-top: 10px;
			padding-top: 20px;
			border-top: 1px solid #f0f0f0;
			
			// 笔记本适配
			@media (max-width: 768px) {
				flex-direction: column;
				gap: 10px;
				padding-top: 16px;
			}
		}

		.btn {
			padding: 12px 24px;
			border: none;
			border-radius: 8px;
			font-size: 14px;
			font-weight: 500;
			cursor: pointer;
			transition: all 0.3s ease;
			display: inline-flex;
			align-items: center;
			gap: 8px;
			
			// 笔记本适配
			@media (max-width: 1280px) {
				padding: 10px 20px;
				font-size: 13px;
			}
			
			@media (max-width: 768px) {
				justify-content: center;
				padding: 12px 16px;
			}
		}

		.btn:disabled {
			opacity: 0.6;
			cursor: not-allowed;
			transform: none !important;
		}

		.btn-primary {
			background: #2280FD;
			color: white;
			box-shadow: 0 2px 8px rgba(34, 128, 253, 0.3);
		}

		.btn-primary:hover:not(:disabled) {
			background: #1a6fd0;
			transform: translateY(-1px);
			box-shadow: 0 4px 12px rgba(34, 128, 253, 0.4);
		}

		.btn-secondary {
			background: white;
			color: #666;
			border: 1px solid #e0e0e0;
		}

		.btn-secondary:hover:not(:disabled) {
			background: #f5f5f5;
			border-color: #ccc;
		}

		/* 查询结果 */
		.results-card {
			background: white;
			border-radius: 12px;
			padding: 30px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
			
			// 笔记本适配
			@media (max-width: 1280px) {
				padding: 24px;
			}
			
			@media (max-width: 1024px) {
				padding: 20px;
				border-radius: 8px;
			}
			
			@media (max-width: 768px) {
				padding: 16px;
			}
		}

		.results-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 24px;
			padding-bottom: 16px;
			border-bottom: 1px solid #f0f0f0;
			
			// 笔记本适配
			@media (max-width: 1280px) {
				margin-bottom: 20px;
				padding-bottom: 12px;
			}
			
			@media (max-width: 768px) {
				flex-direction: column;
				align-items: flex-start;
				gap: 8px;
			}
		}

		.results-title {
			font-size: 18px;
			font-weight: 600;
			color: #333;
			display: flex;
			align-items: center;
			gap: 10px;
			
			// 笔记本适配
			@media (max-width: 1280px) {
				font-size: 16px;
			}
		}

		.results-title i {
			color: #2280FD;
		}

		.results-count {
			color: #666;
			font-size: 14px;
			
			// 笔记本适配
			@media (max-width: 768px) {
				font-size: 13px;
			}
		}

		/* 加载状态 */
		.loading-state {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 60px;
			color: #666;
			font-size: 16px;
			gap: 10px;
			
			// 笔记本适配
			@media (max-width: 768px) {
				padding: 40px 20px;
				font-size: 14px;
			}
		}

		.loading-state i {
			font-size: 20px;
			color: #2280FD;
			animation: rotating 2s linear infinite;
		}

		@keyframes rotating {
			from { transform: rotate(0deg); }
			to { transform: rotate(360deg); }
		}

		/* 空状态 */
		.empty-state {
			text-align: center;
			padding: 60px 20px;
			color: #999;
			
			// 笔记本适配
			@media (max-width: 768px) {
				padding: 40px 20px;
			}
		}

		.empty-icon {
			font-size: 64px;
			color: #e0e0e0;
			margin-bottom: 20px;
			
			// 笔记本适配
			@media (max-width: 768px) {
				font-size: 48px;
				margin-bottom: 16px;
			}
		}

		.empty-text {
			font-size: 16px;
			margin-bottom: 8px;
			color: #666;
			
			// 笔记本适配
			@media (max-width: 768px) {
				font-size: 14px;
			}
		}

		.empty-desc {
			font-size: 14px;
			color: #999;
			
			// 笔记本适配
			@media (max-width: 768px) {
				font-size: 13px;
			}
		}

		.results-table {
			width: 100%;
			border-collapse: collapse;
			
			// 笔记本适配 - 在较小屏幕上水平滚动
			@media (max-width: 1024px) {
				display: block;
				overflow-x: auto;
				white-space: nowrap;
			}
		}

		.results-table th {
			background: #f8f9fa;
			padding: 16px;
			text-align: left;
			font-weight: 600;
			color: #333;
			border-bottom: 1px solid #e0e0e0;
			
			// 笔记本适配
			@media (max-width: 1280px) {
				padding: 12px 14px;
				font-size: 14px;
			}
			
			@media (max-width: 1024px) {
				padding: 10px 12px;
				font-size: 13px;
			}
		}

		.results-table td {
			padding: 16px;
			border-bottom: 1px solid #f0f0f0;
			
			// 笔记本适配
			@media (max-width: 1280px) {
				padding: 12px 14px;
				font-size: 13px;
			}
			
			@media (max-width: 1024px) {
				padding: 10px 12px;
				font-size: 12px;
			}
		}

		.results-table tr:hover {
			background: #f8f9fa;
		}

		.policy-info {
			display: flex;
			flex-direction: column;
			gap: 4px;
		}

		.policy-name {
			font-weight: 500;
			color: #333;
			
			// 笔记本适配
			@media (max-width: 1024px) {
				font-size: 13px;
			}
		}

		.policy-number {
			font-size: 12px;
			color: #666;
			
			// 笔记本适配
			@media (max-width: 1024px) {
				font-size: 11px;
			}
		}

		.policy-time {
			font-size: 12px;
			color: #999;
			
			// 笔记本适配
			@media (max-width: 1024px) {
				font-size: 11px;
			}
		}

		.policy-period {
			display: flex;
			flex-direction: column;
			gap: 2px;
			color: #333;
			font-size: 14px;
			
			// 笔记本适配
			@media (max-width: 1024px) {
				font-size: 12px;
			}
		}

		.policy-amount {
			font-weight: 600;
			color: #2280FD;
			font-size: 16px;
			
			// 笔记本适配
			@media (max-width: 1024px) {
				font-size: 14px;
			}
		}

		.policy-status {
			padding: 6px 12px;
			border-radius: 20px;
			font-size: 12px;
			font-weight: 500;
			display: inline-block;
			
			// 笔记本适配
			@media (max-width: 1024px) {
				padding: 4px 8px;
				font-size: 11px;
			}
		}

		.status-0 {
			background: #fff3e0;
			color: #ef6c00;
		}
		
		.status-1 {
			background: #e3f2fd;
			color: #1976d2;
		}
		
		.status-2 {
			background: #e8f5e9;
			color: #2e7d32;
		}
		
		.status-3 {
			background: #f5f5f5;
			color: #757575;
		}
		
		.status-4 {
			background: #ffebee;
			color: #c62828;
		}

		.policy-actions {
			display: flex;
			gap: 8px;
			flex-wrap: wrap;
			
			// 笔记本适配
			@media (max-width: 1280px) {
				gap: 6px;
			}
			
			@media (max-width: 768px) {
				flex-direction: column;
				gap: 4px;
			}
		}

		.action-btn {
			padding: 8px 12px;
			border: 1px solid #e0e0e0;
			border-radius: 6px;
			background: white;
			color: #666;
			font-size: 12px;
			cursor: pointer;
			transition: all 0.3s ease;
			display: flex;
			align-items: center;
			gap: 4px;
			white-space: nowrap;
			
			// 笔记本适配
			@media (max-width: 1280px) {
				padding: 6px 10px;
				font-size: 11px;
			}
			
			@media (max-width: 768px) {
				padding: 8px 10px;
				justify-content: center;
				font-size: 12px;
			}
		}

		.action-btn:hover:not(:disabled) {
			border-color: #2280FD;
			color: #2280FD;
		}

		.action-btn:disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}

		.action-btn.primary {
			background: #2280FD;
			color: white;
			border-color: #2280FD;
		}

		.action-btn.primary:hover:not(:disabled) {
			background: #1a6fd0;
		}

		/* 分页 */
		.pagination {
			display: flex;
			justify-content: center;
			margin-top: 30px;
			
			// 笔记本适配
			@media (max-width: 1280px) {
				margin-top: 20px;
			}
			
			::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
				background-color: #2280FD;
				color: white;
			}
			
			::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
				color: #2280FD;
			}
			
			// 分页适配
			@media (max-width: 768px) {
				::v-deep .el-pagination {
					.el-pagination__total,
					.el-pagination__jump {
						display: none;
					}
				}
			}
		}
		
		// 在小屏幕上隐藏部分列
		@media (max-width: 768px) {
			.results-table {
				th:nth-child(2),
				td:nth-child(2),
				th:nth-child(3),
				td:nth-child(3) {
					display: none;
				}
			}
		}
	}
</style>